import { useTranslation } from 'react-i18next';
import { checklistProgress, type IChecklistItemLike } from '@d-orca/shared/checklist';
import { CheckCircleIcon } from '@utils/icons';
import styles from './ChecklistChip.module.css';

interface IChecklistChipProps {
  checklist: readonly IChecklistItemLike[] | undefined;
  /** Placement only (spacing in the host row). */
  className?: string;
}

/**
 * A committed task's checklist at a glance: `done/total` checks, amber while
 * they still block Mark done (task-checklist design, decision 10). Nothing
 * when the task has no checks. Shown on the Gantt rail, the Work Plan and the
 * Activities list — anywhere a promise is.
 */
export function ChecklistChip({ checklist, className = '' }: IChecklistChipProps) {
  const { t } = useTranslation();
  const { done, total } = checklistProgress(checklist);
  if (total === 0) return null;
  const open = done < total;
  return (
    <span
      className={`${open ? styles.open : styles.done} ${className}`}
      aria-label={t('scheduler.panel.checklist.progress', { done, total })}
      data-testid="checklist-chip"
    >
      <CheckCircleIcon size={11} />
      {`${done}/${total}`}
    </span>
  );
}
